// Forms: lo que llega de los formularios de la web (POST a /_divflow/form). El constructor de formularios llega en la
// fase 3; de momento cualquier formulario HTML puede mandar aquí.
import { useEffect, useState } from 'react';
import { api } from '../../api.ts';
import { t } from '../../i18n/index.ts';
import { errorText, useApp } from '../../store.ts';
import { ago, fullDate } from '../../format.ts';
import type { SiteProps } from './SiteShell.tsx';

type Submission = { id: string; createdAt: number; form: string | null; data: Record<string, string> };

export function Forms({ site }: SiteProps) {
  const notify = useApp((s) => s.notify);
  const [rows, setRows] = useState<Submission[] | null>(null);

  useEffect(() => {
    api
      .forms(site.id)
      .then((r) => setRows(r.submissions))
      .catch((e) => notify(errorText(e), true));
  }, [site.id, notify]);

  return (
    <section className="section">
      <h2>{t('site.forms')}</h2>
      <p className="hint">{t('forms.hint')}</p>
      <pre className="panel mono" style={{ margin: 0, whiteSpace: 'pre-wrap', color: 'var(--text-label)' }}>
        {`<form method="post" action="/_divflow/form">\n  <input type="hidden" name="_form" value="contact">\n  <input type="text" name="_gotcha" hidden>\n  <input name="email" type="email" required>\n  <button>Send</button>\n</form>`}
      </pre>
      {rows && rows.length === 0 ? <p className="hint">{t('forms.none')}</p> : null}
      <div className="list">
        {(rows ?? []).map((r) => (
          <div key={r.id} className="list-row" style={{ alignItems: 'flex-start' }}>
            <div className="col grow" style={{ gap: 6 }}>
              <div className="row">
                <span className="badge">{r.form ?? t('forms.unnamed')}</span>
                <span className="hint" title={fullDate(r.createdAt)}>
                  {ago(r.createdAt)}
                </span>
              </div>
              {Object.entries(r.data).map(([k, v]) => (
                <div key={k} className="row" style={{ alignItems: 'flex-start' }}>
                  <span className="muted" style={{ width: 120, flexShrink: 0 }}>
                    {k}
                  </span>
                  <span style={{ wordBreak: 'break-word', minWidth: 0 }}>{v}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
